import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function DivisionCard({ division, image, images, description, cta, index }) {
  return (
    <div className="tech-card group relative flex flex-col overflow-hidden" data-testid={`division-card-${division.slug}`}>
      <div className="division-stripe" style={{ background: division.color }} />
      <div className="aspect-[16/10] overflow-hidden bg-slate-100 border-b border-slate-200">
        {Array.isArray(images) && images.length === 2 ? (
          <div className="w-full h-full flex" data-testid={`division-image-split-${division.slug}`}>
            {images.map((img, i) => (
              <div
                key={i}
                className={`relative flex-1 h-full bg-white flex items-center justify-center overflow-hidden ${i === 0 ? "border-r border-slate-200" : ""}`}
              >
                <img
                  src={img.src}
                  alt={img.label}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-contain p-2 transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-1.5 left-1/2 -translate-x-1/2 bg-[#0F2747] text-white text-[10px] font-semibold px-2 py-0.5 rounded-sm tracking-wide whitespace-nowrap">
                  {img.label}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <img src={image} alt={division.label} loading="lazy" decoding="async"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        )}
      </div>
      <div className="p-7 flex flex-col flex-grow">
        <div className="overline text-slate-500">Division {String(index + 1).padStart(2, "0")}</div>
        <h3 className="font-display text-2xl font-bold text-[#1E293B] mt-2">{division.label}</h3>
        <p className="text-slate-600 mt-3 leading-relaxed flex-grow">{description}</p>
        <Link to={`/products/${division.slug}`} className="mt-6 btn-primary self-start" data-testid={`view-${division.slug}`}>
          {cta} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
